export enum ETypCennehoPapiru {
    RK = 'RK',
    JK = 'JK'
}
